import React from "react";
import capabilities1 from "../Assets/Artboard 1.jpg"
import capabilities2 from "../Assets/capabilities2.jpg"
import Logo1 from "../Assets/logo1.png";
import Logo2 from "../Assets/logo2.png";
import Logo3 from "../Assets/logo3.png";
import Logo4 from "../Assets/logo4.png";

function Capabilities() {
const capabilityCards = [
  {
    logo: Logo1,
    title: "Industrial Automation & Control Systems",
    description:
      "Advanced automation solutions for machines, lines and industrial processes with reliable control architecture and smart integration.",
    points: [
      "PLC, HMI and SCADA system design & integration",
      "Motion control, servo systems and VFDs",
      "Robotics including SCARA, 6-axis and collaborative robots",
      "Machine automation and process control",
    ],
  },
  {
    logo: Logo2,
    title: "Energy Efficiency & Sustainability Solutions",
    description:
      "Technologies focused on reducing energy use, improving environmental performance and supporting more sustainable operations.",
    points: [
      "Energy-efficient motors, drives and fans",
      "Emission control solutions for DG sets",
      "Daylighting and ventilation systems",
      "Smart energy monitoring and optimization",
    ],
  },
  {
    logo: Logo3,
    title: "System Integration & Engineering",
    description:
      "End-to-end engineering support covering concept, design, integration and deployment of industrial systems.",
    points: [
      "End-to-end project engineering",
      "Electrical and control panel design",
      "Field instrumentation and industrial devices",
      "OEM-certified system configuration",
    ],
  },
  {
    logo: Logo4,
    title: "Technology Partnerships & Products",
    description:
      "Access to premium technologies and trusted ecosystem partnerships for automation, lighting, ventilation and sustainability solutions.",
    points: [
      "Solutions aligned with Mitsubishi FA, EAPL and Platino Automotive",
      "Skyshade, Paras Green and Binay Opto Electronics",
      "Premium automation and energy solution technologies",
      "Application-focused product selection and deployment",
    ],
  },
];

  const supportAreas = [
    "Manufacturing automation",
    "Utilities applications",
    "Commercial infrastructure",
    "Sustainable engineering solutions",
    "Productivity improvement",
    "Environmental performance enhancement",
  ];

  return (
    <div style={{ backgroundColor: "#f7fbff", overflowX: "hidden" }}>
  <section
  style={{
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 45%, #f7fbff 100%)",
    padding: "90px 0 70px 0",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: "30px",
      left: "-70px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    style={{
      position: "absolute",
      bottom: "20px",
      right: "-60px",
      width: "240px",
      height: "240px",
      borderRadius: "50%",
      background: "rgba(11,92,173,0.10)",
      filter: "blur(10px)",
      animation: "floatY 6s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      <div className="col-lg-6">
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e6f4ff",
            color: "#0B5CAD",
            padding: "10px 18px",
            borderRadius: "30px",
            fontWeight: 700,
            fontSize: "14px",
            marginBottom: "18px",
            animation: "fadeUp 1s ease",
          }}
        >
          OUR CAPABILITIES
        </div>

        <h1
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
            lineHeight: "1.15",
            marginBottom: "18px",
            animation: "fadeUp 1.1s ease",
          }}
        >
          Engineering Capabilities
          <br />
          Built For Industry
        </h1>

        <p
          style={{
            color: "#4a5568",
            fontSize: "17px",
            lineHeight: "1.9",
            marginBottom: "24px",
            animation: "fadeUp 1.2s ease",
          }}
        >
          Electromates combines automation expertise, sustainable
          technologies, engineering integration and trusted technology
          partnerships to help industries improve efficiency,
          productivity and environmental performance.
        </p>

        <div className="row g-3">
          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                4
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Core Domains
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                EndToEnd
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Engineering Focus
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Smart
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Sustainable Solutions
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            position: "relative",
            overflow: "hidden",
            animation: "zoomInSoft 1.2s ease",
            borderRadius: "28px",
            boxShadow: `
              0 12px 28px rgba(11,92,173,0.12),
              0 22px 50px rgba(29,169,232,0.16),
              0 34px 75px rgba(0,119,255,0.12)
            `,
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={capabilities1}
            alt="Capabilities"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
  }}
>
  <div className="container py-4">
    <div className="row justify-content-center mb-5">
      <div className="col-lg-8">
        <div
          style={{
            background: "linear-gradient(135deg, #0B5CAD 0%, #084b8a 100%)",
            borderRadius: "28px",
            padding: "34px 30px",
            textAlign: "center",
            boxShadow: "0 18px 40px rgba(11,92,173,0.16)",
          }}
        >
          <h2
            style={{
              color: "#ffffff",
              fontWeight: 800,
              marginBottom: "12px",
              fontSize: "clamp(1.8rem, 3vw, 2.5rem)",
            }}
          >
            Our Capability Areas
          </h2>

          <p
            style={{
              color: "rgba(255,255,255,0.88)",
              maxWidth: "760px",
              margin: "0 auto",
              lineHeight: "1.8",
              fontSize: "15px",
            }}
          >
            Electromates’ strengths across industrial automation, energy
            efficiency, engineering integration and technology-backed
            solution delivery.
          </p>
        </div>
      </div>
    </div>

    <div className="row g-4">
      {capabilityCards.map((item, index) => (
        <div className="col-lg-3 col-md-6" key={index}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              padding: "24px",
              height: "100%",
              boxShadow: "0 14px 34px rgba(11,92,173,0.08)",
              border: "1px solid rgba(11,92,173,0.06)",
              borderTop: "5px solid #0B5CAD",
              transition: "0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 18px 38px rgba(11,92,173,0.14)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 14px 34px rgba(11,92,173,0.08)";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
                marginBottom: "16px",
              }}
            >
              <div
                style={{
                  width: "62px",
                  height: "62px",
                  minWidth: "62px",
                  borderRadius: "16px",
                  backgroundColor: "#e6f4ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  padding: 0,
                }}
              >
                <img
                  src={item.logo}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>

              <h3
                style={{
                  color: "#0B5CAD",
                  fontWeight: 700,
                  marginBottom: 0,
                  fontSize: "18px",
                  lineHeight: "1.35",
                }}
              >
                {item.title}
              </h3>
            </div>

            <p
              style={{
                color: "#5b6777",
                lineHeight: "1.8",
                marginBottom: "16px",
                fontSize: "14px",
              }}
            >
              {item.description}
            </p>

            <ul style={{ paddingLeft: "18px", marginBottom: 0 }}>
              {item.points.map((point, i) => (
                <li
                  key={i}
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.8",
                    marginBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      <section
        className="py-5"
        style={{
          background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
        }}
      >
        <div className="container py-4">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "24px",
                  padding: "34px",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
                  borderLeft: "6px solid #1DA9E8",
                }}
              >
                <h2
                  style={{
                    color: "#0B5CAD",
                    fontWeight: 800,
                    marginBottom: "18px",
                  }}
                >
                  How Our Capabilities Create Value
                </h2>

                <p style={{ color: "#4a5568", lineHeight: "1.95" }}>
                  Electromates brings together strong engineering fundamentals,
                  solution-centric design and disciplined execution. This
                  enables customers to confidently address complex automation
                  and energy challenges while moving toward smarter and more
                  sustainable operations.
                </p>

                <p
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.95",
                    marginBottom: 0,
                  }}
                >
                  These capabilities support applications across manufacturing,
                  utilities, infrastructure and commercial environments, helping
                  organizations improve reliability, productivity and
                  environmental performance. 
                </p>
              </div>
            </div>

           <div className="col-lg-6">
  <div
    style={{
      minHeight: "340px",
      borderRadius: "24px",
      overflow: "hidden",
    }}
  >
    <img
      src={capabilities2}
      alt="Engineering Deployment"
      style={{
        width: "100%",
        height: "340px",
        objectFit: "cover",
        display: "block",
      }}
    />
  </div>
</div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container py-4">
          <div className="row g-3">
            {supportAreas.map((item, index) => (
              <div className="col-sm-6 col-lg-4" key={index}>
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "18px",
                    padding: "20px",
                    boxShadow: "0 8px 20px rgba(11,92,173,0.06)",
                    color: "#2d3748",
                    fontWeight: 600,
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container py-4">
          <div
            style={{
              background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
              borderRadius: "28px",
              padding: "50px 30px",
              textAlign: "center",
              color: "#ffffff",
              boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
            }}
          >
            <h2 style={{ fontWeight: 800, marginBottom: "14px" }}>
              Looking For a Capability-Driven Engineering Partner?
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto 24px",
                lineHeight: "1.85",
                color: "rgba(255,255,255,0.92)",
              }}
            >
              Electromates delivers automation, energy and engineering
              capabilities that help industries build efficient, reliable and
              future-ready systems.
            </p>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Capabilities;